import React from 'react'
import { t } from 'src/lib/i18n-react'
import { LanguageCode, CefrLevelCode } from 'src/types'
import { getLanguageName } from 'lib/util'
import PageWrapupCelebration from 'src/ui/PageWrapup/subcomponents/PageWrapupCelebration/PageWrapupCelebration'

import enImage from './assets/levelup-english.svg'
import deImage from './assets/levelup-german.svg'
import esImage from './assets/levelup-spanish.svg'
import frImage from './assets/levelup-french.svg'

const ASSETS = {
  [LanguageCode.en]: enImage,
  [LanguageCode.de]: deImage,
  [LanguageCode.es]: esImage,
  [LanguageCode.fr]: frImage,
}

export type Props = {
  cefrLevel: CefrLevelCode
  l2Code: LanguageCode
}

const LevelWrapupCelebration: React.FC<Props> = ({ cefrLevel, l2Code }) => {
  return (
    <PageWrapupCelebration
      title={t('Congratulations!')}
      subtitle={t(
        'You’ve completed <strong>%{cefr}&nbsp;Level</strong> %{l2Name}',
        {
          cefr: cefrLevel.toUpperCase(),
          l2Name: getLanguageName(l2Code),
        }
      )}
      image={{
        url: ASSETS[l2Code] || ASSETS[LanguageCode.de],
        width: 168,
        height: 168,
      }}
    />
  )
}

export default LevelWrapupCelebration
